export const fetchReportData = async (Calc, Provider) => {
  const currSearch = { search: Calc.getCurrSearch() },
    prevSearch = { search: Calc.getPrevSearch() },
    prevFullYearSearch = { search: Calc.getPrevFullYearSearch() }

  const [current, previous, previousFullYear] = await Promise.all([
    Provider.search(currSearch),
    Provider.search(prevSearch),
    Provider.search(prevFullYearSearch),
  ])

  const metrics = [
      'points',
      'enrolled',
      'aca_lives',
      'ma_lives',
      'av',
      'av_no_aca',
      'life_av',
      'med_supps_av',
      'group',
    ],
    timespans = ['wtd', 'mtd', 'qtd', 'ytd'],
    growth = {}

  timespans.forEach(timespan => {
    metrics.forEach(metric => {
      if (!growth.hasOwnProperty(timespan)) growth[timespan] = {}

      let p = 0,
        c = 0

      try {
        p = previous[timespan][metric]
        p = p !== null && !isNaN(p) ? parseFloat(p) : 0
        c = current[timespan][metric]
        c = c !== null && !isNaN(c) ? parseFloat(c) : 0
      } catch (ex) {}

      growth[timespan][metric] = c === 0 && p === 0 ? 0 : p === 0 ? 1 : (c - p) / p
    })
  })

  return { current, previous, previousFullYear, growth }
}
